import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import api from '../../config/axions.config';
import Swal from 'sweetalert2'
import { toast } from 'sonner';
import { MdOutlineFileUpload } from "react-icons/md";
import { MdDelete } from "react-icons/md";
import { showDate } from '../../constant';
import { IoMdClose } from "react-icons/io";

const EditStudents = () => {
  let navigate = useNavigate();

  var getInfo = localStorage.getItem('User') || "{}";
  let admin = JSON.parse(getInfo);
  let location = useLocation();
  let data = location.state
  const inputRefPhoto = useRef();
  const inputRefId = useRef();

  // main data state
  const [activeTab, setActiveTab] = useState(0); // Initial active tab is the first one
  const [payment_typeList, setPayment_typeList] = useState([]);
  const [courseList, setCourseList] = useState([])
  const [admissionTypeList, setAdmissionTypeList] = useState([])
  const [streamList, setStreamList] = useState([]);
  const [collageList, setCollageList] = useState([]);

  // Add Student Step - 1 Variables
  const [file, setFile] = useState();
  const [firstname, setFirsntame] = useState(data?.firstname);
  const [lastname, setLastname] = useState(data?.lastname);
  const [email, setEmail] = useState(data?.email);
  const [mobile, setMobile] = useState(data?.mobile);
  const [parent_mobile, setParent_mobile] = useState(data?.parent_mobile);
  const [collage_id, setCollage_id] = useState(data?.collage_id);
  const [stream_id, setStream_id] = useState(data?.stream_id);
  const [dob, setDob] = useState(data?.dob.split("T")[0]);
  const [address, setAddress] = useState(data?.address);
  const [gender, setGender] = useState(data?.gender);
  const [image, setImage] = useState({ Bytes: "", filename: "" });
  const [studentId, setStudentId] = useState(data?._id)
  const [id, setId] = useState({ Bytes: "", filename: "" });
  const [studentActive, setStudentActive] = useState(data?.is_active)
  const [course_id, setCourse_id] = useState(data.enrollmentsData[0]?.courseDetail._id || ''); // Default to the first enrolled course
  const [enrolledCourses, setEnrolledCourses] = useState(data.enrollmentsData.map(enrollment => ({
    id: enrollment.courseDetail._id,
    name: enrollment.courseDetail.name
  })));
  const [isOpen, setIsOpen] = useState(false);

  //Add studnt Step - 2 Enrollment Variables
  const selectedEnrollment = data.enrollmentsData.find(enrollment => enrollment.courseDetail._id === course_id) || {};
  const [admission_type, setAdmission_type] = useState({
    type: selectedEnrollment?.admissionDetail?.type || '',
    id: selectedEnrollment?.admissionDetail?._id || ''
  });
  const [duration, setDuration] = useState(selectedEnrollment?.duration || '');
  const [total_fee, setTotal_fee] = useState(selectedEnrollment?.total_fee || '');
  const [no_of_installments, setNo_of_installments] = useState(selectedEnrollment?.no_of_installments || '');
  const [duration_type, setDuration_type] = useState(selectedEnrollment?.duration_type || '');
  const [startDate, setStartDate] = useState(selectedEnrollment?.start_date?.split("T")[0] || '');
  const [endDate, setEndDate] = useState(selectedEnrollment?.end_date || '');
  const [tutor, setTutor] = useState(selectedEnrollment?.tutor || []);
  const [enrolled_by, setEnrolled_by] = useState(selectedEnrollment?.enrolled_by || '');
  const [installments, setInstallments] = useState('');
  const [courese_id, setCourese_id] = useState(data.enrollmentsData[data.enrollmentsData.length - 1]?.courseDetail.name)
  const [payment_type, setPayment_type] = useState(data?.payment_type);
  const [tutorList, setTutorList] = useState([]);
  const [tutorFieldValue, setTutorFieldValue] = useState('');
  const [ student_id, setStudent_id] = useState(data._id);
  const [selectedEnrollmentId, setSelectedEnrollmentId] = useState(
    data.enrollmentsData.find(enrollment => enrollment.courseDetail._id === course_id)?._id || ''
  );
  

  //ResponseData
  const [studentData, setStudentData] = useState({});
  const [enrollmentData, setEnrollmentData] = useState();
  const [selectedPhoto, setSelectedPhoto] = useState(null);
  const [selectedId, setSelectedId] = useState(null);
  const [photo, setPhoto] = useState({ Bytes: "", filename: "" });


  const handleTutorFileKey = (e) => {
      if (e.key === "Enter") {
        if (tutorFieldValue) {
          tutor.push(tutorFieldValue);
          setTutorFieldValue('');
        }
        else {
          toast.error("input Language field")
        }
      }
    }
    const handleTutorListItemRemove = (e) => {
      let result = tutor.filter((item) => item !== e.target.id)
      setTutor(result);
    }


  // For Photo seelection
  const handleOnchange = (event) => {
    if (event.target.files && event.target.files.length > 0) {
      setSelectedPhoto(event.target.files[0]);
      setPhoto({ Bytes: event.target.files[0], filename: URL.createObjectURL(event.target.files[0]) })
    }
  }

  const onChooseFile = (event) => {
    event.preventDefault(); // Prevent form submission
    inputRefPhoto.current.click();
  }

  const removeFile = () => {
    setSelectedPhoto(null)
  }

  // For Id selection
  const handleOnchangeId = (event) => {
    if (event.target.files && event.target.files.length > 0) {
      setSelectedId(event.target.files[0]);
      setId({ Bytes: event.target.files[0], filename: URL.createObjectURL(event.target.files[0]) })
    }
  }

  const onChooseId = (event) => {
    event.preventDefault(); // Prevent form submission
    inputRefId.current.click();
  }

  const removeId = () => {
    setSelectedId(null)
  }

  async function getPaymentType() {
    try {
      let responce = await api.get("paymentType")
      if (responce?.data.status) {
        setPayment_typeList(responce.data.data.PaymentTypes);
      } else {
        toast.error(responce.data.message)
      }
    } catch (error) {
      console.log(error);
    }
  }

  async function getCourseList() {
    try {
      let responce = await api.get("course")
      if (responce?.data.status) {
        setCourseList(responce.data.data.courses);
      } else {
        toast.error(responce.data.message)
      }
    } catch (error) {
      console.log(error);
    }
  }

  async function getAdmissionType() {
    try {
      let responce = await api.get("admissionType")
      if (responce?.data.status) {
        setAdmissionTypeList(responce.data.data.AdmissionTypes);
      } else {
        toast.error(responce.data.message)
      }
    } catch (error) {
      console.log(error);
    }
  }

  async function getCollegList() {
    try {
      let responce = await api.get("collage")
      if (responce?.data.status) {
        setCollageList(responce.data.data.colleges);
      } else {
        toast.error(responce.data.message)
      }
    } catch (error) {
      console.log(error);
    }
  }

  async function getStreamList() {
    try {
      let responce = await api.get("stream")
      if (responce?.data.status) {
        setStreamList(responce.data.data.streams);
      } else {
        toast.error(responce.data.message)
      }
    } catch (error) {
      console.log(error);
    }
  }

  const handleOpenPopup = () => {
    setIsOpen(true);
  }

  const handleClosePopup = () => {
    setIsOpen(false);
  }

  function setCourse(e) {
    setCourse_id(e.target.value);
    setDuration_type(e.target.selectedOptions[0].getAttribute('duration_type'))
    setTutorFieldValue(e.target.selectedOptions[0].getAttribute('tutor'));
    setDuration(e.target.selectedOptions[0].getAttribute('duration'));
    setTotal_fee(e.target.selectedOptions[0].getAttribute('total_fee'))
  }

  async function updateEnrollType() {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to update this enrollment?!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#4CAF50",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Update it!"
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await api.patch(`enrollment/${selectedEnrollmentId}`, {
            course_id,
            tutor,
            admission_type: admission_type.id,
            duration,
            total_fee,
            no_of_installments,
            duration_type,
            start_date:startDate,
            end_date:endDate,
            enrolled_by,
            student_id
          });
          if (response.data.status) {
            toast.success(response.data.message);
          } else {
            toast.error(response.data.message);
          }
        } catch (error) {
          console.error("Error updating enrollment:", error);
          toast.error("Failed to update enrollment. Please try again.");
        }
      } else {
        toast.error("OK! Request canceled.");
      }
    });
  }

  async function updateStudentType() {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to update this student?!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#4CAF50",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Update it!"
    }).then(async (result) => {
      if (result.isConfirmed) {
        const formData = new FormData();
        formData.append("firstname", firstname);
        formData.append("lastname", lastname);
        formData.append("email", email);
        formData.append("mobile", mobile);
        formData.append("parent_mobile", parent_mobile);
        formData.append("address", address);
        formData.append("collage_id", collage_id);
        formData.append("stream_id", stream_id)
        formData.append("gender", gender)
        formData.append("dob", dob)
        formData.append("image", image.Bytes)
        formData.append("id", id.Bytes)

        let responce = await api.patch(`student/${data._id}`, formData)
        if (responce.data.status) {
          toast.success(responce.data.message);
        } else {
          toast.error(responce.data.message);
        }
      } else {
        toast.error("OK! request cancle.")
      }
    });
  }

  const tabClick = (index) => {
    setActiveTab(index);
  };

  function handleChange(e) {
    setFile(URL.createObjectURL(e.target.files[0]));
  }
  useEffect(() => {
    if (startDate && duration > 0 && duration_type) {
      const start = new Date(startDate);
      if (duration_type === "months") {
        start.setMonth(start.getMonth() + parseInt(duration)); // Adding the duration in months
      } else if (duration_type === "days") {
        start.setDate(start.getDate() + parseInt(duration)); // Adding the duration in days
      }
      setEndDate(start.toISOString().split('T')[0]); // Format to YYYY-MM-DD
    } else {
      setEndDate(''); // Clear end date if inputs are invalid
    }
  }, [startDate, duration, duration_type]);
  useEffect(() => {
    getCollegList();
    getStreamList();
    getCourseList();
    getAdmissionType();
    getPaymentType()
  }, [])

  useEffect(() => {
    const selectedEnrollment = data.enrollmentsData.find(enrollment => enrollment.courseDetail._id === course_id) || {};
    setSelectedEnrollmentId(selectedEnrollment?._id || '');
    setAdmission_type({
      type: selectedEnrollment?.admissionDetail?.type || '',
      id: selectedEnrollment?.admissionDetail?._id || ''
    });
    setDuration(selectedEnrollment?.duration || '');
    setTotal_fee(selectedEnrollment?.total_fee || '');
    setNo_of_installments(selectedEnrollment?.no_of_installments || '');
    setDuration_type(selectedEnrollment?.duration_type || '');
    setStartDate(selectedEnrollment?.start_date?.split("T")[0] || '');
    setEndDate(selectedEnrollment?.end_date || '');
    setTutor(selectedEnrollment?.tutor || []);
    setEnrolled_by(selectedEnrollment?.enrolled_by || '');
  }, [course_id, data.enrollmentsData]);

  const handleFormKeyDown = (event) => {
    if (event.key === "Enter" && event.target.type !== "textarea" && event.target.type !== "submit") {
      event.preventDefault(); // Prevent form submission
    }
  };

  function handleCourseChange(e) {
    setCourse_id(e.target.value);
  }

  return (
    <div className='grow ms-0 md:ms-0 lg:ms-56'>
      {
        isOpen && (
          <div className='absolute bg-black bg-opacity-50 z-[999] flex justify-center items-center h-full w-full'>
            <div>
              <div id="addNewCourseModal" aria-labelledby="modal-title" role="dialog" aria-hidden="true" tabIndex="-1">
                <div className="modal-overlay" tabIndex="-1"></div>
                <div className="modal-dialog modal-dialog-scrollable md:max-w-4xl xl:max-w-5xl">
                  <div className="modal-content" role="document">
                    <div className="modal-header">
                      <h5 className="mr-12 text-lg font-bold truncate">
                        Payment Collection
                      </h5>

                      <button type="button" className="btn-close" data-dismiss="modal" aria-label="Close" onClick={handleClosePopup}>
                        <span className="sr-only">
                          Close
                        </span>
                        <svg className="w-6 h-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                        </svg>
                      </button>
                    </div>

                    <div className="modal-body">
                      <form action="#" method="POST">
                        <div className="grid grid-cols-2 sm:grid-cols-4 gap-x-5 gap-y-4">
                          <div className="col-span-2">
                            <label htmlFor="">
                              Student Name
                            </label>
                            <div className="mt-1 ">
                              <input type="text" value={firstname + " " + lastname} />
                            </div>
                          </div>

                          <div className="col-span-2">
                            <label htmlFor="">
                              Student Id
                            </label>
                            <div className="mt-1 ">
                              <input type="number" value={studentId} />
                            </div>
                          </div>

                          <div className="col-span-2 sm:col-span-4 md:col-span-2">
                            <label htmlFor="">
                              Payment Type <span className="text-primary-600">*</span>
                            </label>
                            <div className="mt-1">
                              <select onChange={(e) => setPayment_type(e.target.value)} >
                                <option value={null}>
                                  {"Please chose Payment Type"}
                                </option>
                                {
                                  payment_typeList?.filter((item) => item.is_active === true)?.map(item => (
                                    <option key={item._id} value={item._id}>
                                      {item.type}
                                    </option>
                                  ))
                                }
                              </select>
                            </div>
                          </div>

                          <div className="col-span-2">
                            <label htmlFor="">
                              Payment Date
                            </label>
                            <div className="mt-1 ">
                              <input type="date" />
                            </div>
                          </div>

                          <div className="col-span-2">
                            <label htmlFor="">
                              Total Amount
                            </label>
                            <div className="mt-1">
                              <div className="relative rounded-md shadow-sm">
                                <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                                  <span className="text-gray-500 sm:text-sm">
                                    &#8377;
                                  </span>
                                </div>
                                <input type="number" name="" id="" placeholder="" className="!pl-7 !pr-12" required />
                                <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                                  <span className="text-gray-500 sm:text-sm">
                                    RS
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="col-span-2">
                            <label htmlFor="">
                              Installments
                            </label>
                            <div className="mt-1 ">
                              <input type="number" />
                            </div>
                          </div>

                          <div className="col-span-2 sm:col-span-4">
                            <label htmlFor="">
                              Upload Screenshot
                            </label>
                            <div className="mt-1">
                              <div className='flex'>
                                <input type="file" className='' onChange={handleChange} />
                                <img src={file} alt='Screenshot' className='w-1/6' />
                              </div>
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>

                    <div className="modal-footer">
                      <div className="flex items-center justify-end space-x-4">
                        <button type="button" className="btn btn-light" data-dismiss="modal" aria-label="Close Modal">
                          Discard
                        </button>
                        <button type="button" className="btn btn-primary">
                          Save
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        )
      }
      <div className="px-4 mt-6 mb-8 sm:px-6 lg:px-8">
        <nav className="sm:hidden" aria-label="Back">
          <div className="flex items-center text-sm font-medium text-gray-500 hover:text-gray-700">
            <svg className="flex-shrink-0 w-5 h-5 mr-1 -ml-1 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
              <path fillRule="evenodd" d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z" clipRule="evenodd" />
            </svg>
            Back
          </div>
        </nav>

        <nav className="hidden sm:flex" aria-label="Breadcrumb">
          <ol className="flex items-center space-x-4">
            <li>
              <div>
                <div className="text-gray-400 hover:text-gray-500">
                  <svg className="flex-shrink-0 w-5 h-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                    <path d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011-1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z" />
                  </svg>
                  <span className="sr-only">Home</span>
                </div>
              </div>
            </li>

            <li>
              <div className="flex items-center">
                <svg className="flex-shrink-0 w-5 h-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                  <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" />
                </svg>
                <div className="ml-4 text-sm text-gray-500 hover:text-gray-700" onClick={() => navigate('/dashboard/students/')}>
                  Students
                </div>
              </div>
            </li>

            <li>
              <div className="flex items-center">
                <svg className="flex-shrink-0 w-5 h-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                  <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" />
                </svg>
                <div className="ml-3 text-sm text-gray-500 hover:text-gray-700" aria-current="page">
                  Edit Student
                </div>
              </div>
            </li>
          </ol>
        </nav>

        <hr className="my-5 border-gray-300" />

        <div className="lg:flex lg:items-center lg:space-x-8">
          <div className="lg:flex-1 lg:min-w-0">
            <h1 className="text-2xl font-semibold text-primary-600">
              Students
            </h1>
            <div className="mt-2 md:mt-3 sm:flex sm:items-center sm:space-x-6">
              <div className="flex items-center space-x-3">
                <svg className="w-5 h-5 text-gray-500" stroke="currentColor" viewBox="0 0 256 256">
                  <polyline points="80 40 24 128 80 216" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="20"></polyline>
                  <polyline points="176 40 232 128 176 216" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="20"></polyline>
                </svg>
                <span className="text-gray-600">
                  Student Id
                </span>
              </div>

              <div className="flex items-center mt-3 space-x-3 sm:mt-0">
                <svg className="w-5 h-5 text-gray-500" stroke="currentColor" viewBox="0 0 256 256">
                  <rect x="40" y="40" width="176" height="176" rx="8" strokeWidth="20" strokeLinecap="round" strokeLinejoin="round" fill="none"></rect>
                  <line x1="176" y1="20" x2="176" y2="40" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="20"></line>
                  <line x1="80" y1="20" x2="80" y2="40" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="20"></line>
                  <line x1="40" y1="88" x2="216" y2="88" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="20"></line>
                </svg>
                <span className="text-gray-600">
                  Started - {showDate(data.created_at)}
                </span>
              </div>
            </div>
          </div>

          <div className="flex items-center mt-5 ml-auto space-x-6 lg:justify-end lg:mt-0 lg:flex-shrink-0">
            <div className="flex items-center space-x-2">
              <label htmlFor="">
                Student Status
              </label>
              <div className="toggle-switch">
                <input type="checkbox" id="toggleSwitch" checked={studentActive} onChange={() => setStudentActive(!studentActive)} value={true} />
                <label htmlFor="toggleSwitch"></label>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-6 space-y-6">
          <div className="bg-white rounded-lg shadow">
            <div className="px-4 sm:px-6">
              <div className='flex justify-between items-center'>
                <div className="flex items-center -ml-2">
                  <div title="Back" className="btn-circle" aria-label="Back" data-microtip-position="top" data-target="tooltip" role="button" onClick={() => navigate('/dashboard/students/')}>
                    <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M7 16l-4-4m0 0l4-4m-4 4h18" />
                    </svg>
                  </div>

                  <h2 className="ml-2 text-lg font-medium leading-6 text-gray-900">
                    Edit Student
                  </h2>
                </div>
                <div className="px-4 sm:px-6 items-end">
                  <nav className="flex -mb-px space-x-8" aria-label="Tabs">
                    <div title="" aria-current="page" onClick={() => tabClick(0)} className={activeTab === 0 ? 'active text-primary-600 border-b-2 border-primary-600' : ''}>
                      <div className='px-1 py-5 text-sm font-medium border-primary-600 hover:cursor-pointer'>Step 1</div>
                    </div>

                    <div title="" onClick={() => tabClick(1)} className={activeTab === 1 ? 'active text-primary-600 border-b-2 border-primary-600' : ''}>
                      <div className='px-1 py-5 text-sm font-medium items-center hover:cursor-pointer'>Step 2</div>
                    </div>
                  </nav>
                </div>
              </div>
            </div>

            <div className="px-4 py-5 border-t border-gray-300 sm:px-6">
              {
                activeTab === 0 &&
                <div>
                  <form action={updateStudentType} onKeyDown={handleFormKeyDown}>
                    <div className="grid grid-cols-3 sm:grid-cols-3 gap-x-5 gap-y-4">
                      <div className="col-span-1 sm:col-span-3 md:col-span-1">
                        <label htmlFor="">
                          First Name <span className="text-primary-600">*</span>
                        </label>
                        <div className="mt-1">
                          <input type="text" value={firstname} onChange={(e) => setFirsntame(e.target.value)} name="" id="" placeholder="" className="" />
                        </div>
                      </div>

                      <div className="col-span-1 sm:col-span-3 md:col-span-1">
                        <label htmlFor="">
                          Last Name <span className="text-primary-600">*</span>
                        </label>
                        <div className="mt-1">
                          <input type="text" value={lastname} onChange={(e) => setLastname(e.target.value)} name="" id="" placeholder="" className="" />
                        </div>
                      </div>

                      <div className="col-span-1 sm:col-span-3 md:col-span-1">
                        <label htmlFor="">
                          Email <span className="text-primary-600">*</span>
                        </label>
                        <div className="mt-1">
                          <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} name="" id="" placeholder="" className="" />
                        </div>
                      </div>

                      <div className="col-span-1 sm:col-span-3 md:col-span-1">
                        <label htmlFor="">
                          Student Contact <span className="text-primary-600">*</span>
                        </label>
                        <div className="mt-1">
                          <div className="relative rounded-md shadow-sm">
                            <input type="number" value={mobile} onChange={(e) => setMobile(e.target.value)} name="" id="" placeholder="" className="" />
                          </div>
                        </div>
                      </div>

                      <div className="col-span-1 sm:col-span-3 md:col-span-1">
                        <label htmlFor="">
                          Parent's Contact <span className="text-primary-600">*</span>
                        </label>
                        <div className="mt-1">
                          <div className="relative rounded-md shadow-sm">
                            <input type="number" value={parent_mobile} onChange={(e) => setParent_mobile(e.target.value)} name="" id="" placeholder="" className="" />
                          </div>
                        </div>
                      </div>

                      <div className="col-span-1 sm:col-span-3 md:col-span-1">
                        <label htmlFor="">
                          Gender <span className="text-primary-600">*</span>
                        </label>
                        <div className="mt-1">
                          <select name="" id="" className="">
                            <option value="male">
                              Male
                            </option>
                            <option value="female">
                              Female
                            </option>
                          </select>
                        </div>
                      </div>

                      <div className="col-span-2 sm:col-span-3 md:col-span-2">
                        <label htmlFor="">
                          Student Address
                        </label>
                        <div className="mt-1">
                          <input type="text" value={address} onChange={(e) => setAddress(e.target.value)} name="" id="" placeholder="" className=""/>
                        </div>
                      </div>

                      <div className="col-span-1 sm:col-span-3 md:col-span-1">
                        <label htmlFor="">
                          DOB <span className="text-primary-600">*</span>
                        </label>
                        <div className="mt-1">
                          <input type="date" value={dob} onChange={(e) => setDob(e.target.value)} name="" id="" placeholder="" className="" />
                        </div>
                      </div>

                      <div className="col-span-2 sm:col-span-3 md:col-span-2">
                        <label htmlFor="">
                          Collage Name <span className="text-primary-600">*</span>
                        </label>
                        <div className="mt-1">
                          <select name="" id="" value={collage_id} onChange={(item) => setCollage_id(item.target.value)} className="">
                            <option value={""} >
                              {data.collage_name}
                            </option>
                            {
                              collageList?.map(item => (
                                <option key={item._id} value={item._id}>
                                  {item.name}{" "}{item.city}
                                </option>
                              ))
                            }
                          </select>
                        </div>
                      </div>

                      <div className="col-span-1 sm:col-span-3 md:col-span-1">
                        <label htmlFor="">
                          Stream <span className="text-primary-600">*</span>
                        </label>
                        <div className="mt-1">
                          <select name="" id="" value={stream_id} onChange={(item) => setStream_id(item.target.value)} className="">
                            <option value={""} >
                              {data.stream_name}
                            </option>
                            {
                              streamList?.map(item => (
                                <option key={item._id} value={item._id}>
                                  {item.name}
                                </option>
                              ))
                            }
                          </select>
                        </div>
                      </div>

                      <div className='col-span-3 sm:col-span-1 md:col-span-3'>
                        <div className='grid grid-cols-4 sm:grid-cols-4 gap-x-5 gap-y-4'>
                          <div className='col-span-1 sm:col-span-3 md:col-span-1'>
                            <label htmlFor="">
                              Upload Photo
                            </label>
                            <div className="mt-1">
                              <input type="file" ref={inputRefPhoto} style={{ display: "none" }} onChange={handleOnchange}/>
                              <button className='file-btn' onClick={onChooseFile}>
                                <MdOutlineFileUpload className='w-6 h-6' />
                                <span>Upload File</span>
                              </button>

                              {selectedPhoto && <div className='selected-file'>
                                <p>{selectedPhoto.name}</p>
                                <button onClick={removeFile}>
                                  <MdDelete />
                                </button>
                              </div>}
                            </div>
                          </div>

                          <div className='col-span-1 sm:col-span-3 md:col-span-1'>
                            <label htmlFor="">
                              Upload Aadhar Id
                            </label>
                            <div className="mt-1">
                              <input type="file" ref={inputRefId} style={{ display: "none" }} onChange={handleOnchangeId}/>
                              <button className='file-btn' onClick={onChooseId}>
                                <MdOutlineFileUpload className='w-6 h-6' />
                                <span>Upload File</span>
                              </button>

                              {selectedId && <div className='selected-file'>
                                <p>{selectedId.name}</p>
                                <button onClick={removeId}>
                                  <MdDelete />
                                </button>
                              </div>}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="flex items-center justify-end mt-5 space-x-4">
                      <button type="button" className="btn btn-light" onClick={() => navigate('/dashboard/students/')}>
                        Back
                      </button>

                      <button type="submit" className="btn btn-primary">
                        Update Student
                      </button>
                    </div>
                  </form>
                </div>
              }
              {
                activeTab === 1 &&
                <div>
                  <form action={updateEnrollType} onKeyDown={handleFormKeyDown}>
                    <div className="grid grid-cols-2 sm:grid-cols-4 gap-x-5 gap-y-4">
                      <div className="col-span-2 sm:col-span-4 md:col-span-2">
                        <label htmlFor="">
                          Admission Type <span className="text-primary-600">*</span>
                        </label>
                        <div className="mt-1">
                          <select
                            value={admission_type.id}
                            onChange={(e) =>
                              setAdmission_type({
                                id: e.target.value,
                                type: e.target.selectedOptions[0].text
                              })
                            }
                          >
                            <option value={admission_type.id}>
                              {admission_type.type || "Please choose Admission Type"}
                            </option>
                            {admissionTypeList?.map((item) => (
                              <option key={item._id} value={item._id}>
                                {item.type}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>

                      <div className="col-span-2 sm:col-span-4 md:col-span-2">
                        <label htmlFor="">
                          Course <span className="text-primary-600">*</span>
                        </label>
                        <div className="mt-1">
                          <select value={course_id} onChange={handleCourseChange}>
                            {enrolledCourses.map(course => (
                              <option key={course.id} value={course.id}>
                                {course.name}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>

                      <div className="col-span-2 sm:col-span-4 md:col-span-2">
                        <label htmlFor="">
                          Course Duration
                        </label>
                        <div className="mt-1">
                          <input
                            type="number"
                            value={duration}
                            onChange={(e) => setDuration(e.target.value)}
                            placeholder="Months"
                          />
                        </div>
                      </div>

                      <div className='col-span-2 sm:col-span-4 md:col-span-2'>
                        <label htmlFor="">
                          Duration Type <span className="text-primary-600">*</span>
                        </label>

                        <div className="mt-1">
                          <div className="relative rounded-md shadow-sm">
                            <select name="" id="" onChange={(e) => setDuration_type(e.target.value)}>
                              <option value="">
                                {duration_type}
                              </option>
                              <option value="days">
                                Days
                              </option>
                              <option value="months">
                                Months
                              </option>
                            </select>
                          </div>
                        </div>
                      </div>

                      <div className="col-span-2 sm:col-span-4 md:col-span-2">
                        <label htmlFor="">
                          Total Fees <span className="text-primary-600">*</span>
                        </label>
                        <div className="mt-1">
                          <div className="relative rounded-md shadow-sm">
                            <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                              <span className="text-gray-500 sm:text-sm">
                                &#8377;
                              </span>
                            </div>
                            <input type="number" value={total_fee} onChange={(e) => setTotal_fee(e.target.value)} name="" id="" placeholder="" className="!pl-7 !pr-12" required />
                            <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                              <span className="text-gray-500 sm:text-sm">
                                RS
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-span-2 sm:col-span-4 md:col-span-2">
                        <label htmlFor="">
                          Enrolled By <span className="text-primary-600">*</span>
                        </label>
                        <div className="mt-1">
                          <input type="text" value = {admin.firstname + " " + admin.lastname} className=""  readOnly/>
                        </div>
                      </div>

                      <div className="col-span-2 sm:col-span-4 md:col-span-2">
                        <div className='grid grid-cols-2 sm:grid-cols-4 gap-x-5 gap-y-4'>
                          <div className='col-span-2 sm:col-span-4 md:col-span-2'>
                            <label htmlFor="">
                              Start Date <span className="text-primary-600">*</span>
                            </label>

                            <div className="mt-1">
                              <div className="relative rounded-md shadow-sm">
                                <input
                                  type="date"
                                  value={startDate}
                                  onChange={(e) => setStartDate(e.target.value)}
                                  placeholder=""
                                />
                              </div>
                            </div>
                          </div>
                          <div className='col-span-2 sm:col-span-4 md:col-span-2'>
                            <label htmlFor="">
                              End Date <span className="text-primary-600">*</span>
                            </label>

                            <div className="mt-1">
                              <div className="relative rounded-md shadow-sm">
                                <input
                                  type="date"
                                  value={endDate}
                                  readOnly
                                  placeholder=""
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-span-2 sm:col-span-4 md:col-span-2">
                        <label htmlFor="">
                          Tutor
                        </label>
                        <div className="mt-1">
                          <input type="text" value={tutorFieldValue} onChange={(e) => setTutorFieldValue(e.target.value)} onKeyDown={(e) => handleTutorFileKey(e)} />
                          <div className='w-full p-2 my-1 mb-2 flex-1 sm:text-sm rounded-md flex flex-wrap gap-2 overflow-hidden !absolute'>
                            {
                              tutor?.map((item, index) => <p key={index} className='px-2 items-center gap-1 flex justify-center bg-sky-200  rounded-3xl' >{item}<IoMdClose id={item} onClick={(e) => handleTutorListItemRemove(e)} width={"10px"} /></p>)
                            }
                          </div>
                        </div>
                      </div>

                      <div className="col-span-2 sm:col-span-4 md:col-span-2">
                        <label htmlFor="">
                          No. of Installments <span className="text-primary-600">*</span>
                        </label>
                        <div className="mt-1">
                          <input type="number" value={no_of_installments} onChange={(e) => setNo_of_installments(e.target.value)} name="" id="" placeholder="" className="" />
                        </div>
                      </div>
                    </div>

                    <div className="flex items-center justify-end mt-5 space-x-4">
                      <button type="button" className="btn btn-light" onClick={() => navigate('/dashboard/students/')}>
                        Back
                      </button>

                      <button type="submit" className="btn btn-primary">
                        Update Enrollment
                      </button>
                    </div>
                  </form>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default EditStudents
